// @ts-nocheck
import RequestBase from './request-base';


/** 获取当前的用户 GET /api/v1/admin/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return RequestBase.get<API.CurrentUser>('/api/v1/admin/currentUser', {}, options);
}

/** 更新当前用户信息 PUT /api/v1/admin/currentUser */
export async function updateCurrentUser(body: {
  email?: string;
  phone?: string;
  password?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.put<API.CurrentUser>('/api/v1/admin/currentUser', body, options);
}

/** 登录接口 POST /api/v1/admin/users/login */
export async function login(body: any, options?: { [key: string]: any }) {
  return RequestBase.postWithoutAuth<API.LoginResult>('/api/v1/admin/login', body, options);
}

/** 获取设备列表 GET /api/v1/admin/devices */
export async function getDevices(params: any, options?: { [key: string]: any }) {
  return RequestBase.get('/api/v1/admin/devices', params, options);
}

/** 获取区域列表 GET /api/v1/admin/regions */
export async function getRegions(params?: {
  page?: number;
  pageSize?: number;
  name?: string;
  groupId?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.RegionListResponse>('/api/v1/admin/regions', params, options);
}

/** 获取用户列表 GET /api/v1/admin/users */
export async function getUsers(params?: {
  page?: number;
  pageSize?: number;
  username?: string;
  email?: string;
  phone?: string;
  role?: string;
  status?: string;
  [key: string]: any;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.UserListResponse>('/api/v1/admin/users', params, options);
}

/** 根据ID获取用户 GET /api/v1/admin/users/{id} */
export async function getUserById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.UserResponse>(`/api/v1/admin/users/${id}`, {}, options);
}

/** 创建用户 POST /api/v1/admin/users */
export async function createUser(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.UserResponse>('/api/v1/admin/users', body, options);
}

/** 更新用户 PUT /api/v1/admin/users/{id} */
export async function updateUser(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.UserResponse>(`/api/v1/admin/users/${id}`, body, options);
}

/** 删除用户 DELETE /api/v1/admin/users/{id} */
export async function deleteUser(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/users/${id}`, options);
}

/** 获取模型列表 GET /api/v1/admin/ml-models */
export async function getModels(params?: API.ModelSearchParams, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelListResponse>('/api/v1/admin/ml-models', params, options);
}

/** 根据ID获取模型详情 GET /api/v1/admin/ml-models/{id} */
export async function getModelById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelResponse>(`/api/v1/admin/ml-models/${id}`, {}, options);
}

/** 创建模型 POST /api/v1/admin/ml-models */
export async function createModel(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.ModelResponse>('/api/v1/admin/ml-models', body, options);
}

/** 更新模型 PUT /api/v1/admin/ml-models/{id} */
export async function updateModel(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.ModelResponse>(`/api/v1/admin/ml-models/${id}`, body, options);
}

/** 删除模型 DELETE /api/v1/admin/ml-models/{id} */
export async function deleteModel(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/ml-models/${id}`, options);
}

/** 获取系统信息 GET /api/v1/admin/system/info */
export async function getSystemInfo(options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemInfoResponse>('/api/v1/admin/system/info', {}, options);
}

/** 获取系统统计信息 GET /api/v1/admin/system/stats */
export async function getSystemStats(options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemStatsResponse>('/api/v1/admin/system/stats', {}, options);
}

/** 获取CPU信息 GET /api/v1/admin/system/cpu */
export async function getCPUInfo(options?: { [key: string]: any }) {
  return RequestBase.get<API.CPUInfoResponse>('/api/v1/admin/system/cpu', {}, options);
}

/** 获取内存信息 GET /api/v1/admin/system/memory */
export async function getMemoryInfo(options?: { [key: string]: any }) {
  return RequestBase.get<API.MemoryInfoResponse>('/api/v1/admin/system/memory', {}, options);
}

/** 获取磁盘信息 GET /api/v1/admin/system/disks */
export async function getDiskInfo(options?: { [key: string]: any }) {
  return RequestBase.get<API.DiskInfoResponse>('/api/v1/admin/system/disks', {}, options);
}

/** 获取网络信息 GET /api/v1/admin/system/network */
export async function getNetworkInfo(options?: { [key: string]: any }) {
  return RequestBase.get<API.NetworkInfoResponse>('/api/v1/admin/system/network', {}, options);
}

/** 获取进程信息 GET /api/v1/admin/system/processes */
export async function getProcessInfo(params?: {
  limit?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.ProcessInfoResponse>('/api/v1/admin/system/processes', params, options);
}

/** 获取Go运行时信息 GET /api/v1/admin/system/go-runtime */
export async function getGoRuntimeInfo(options?: { [key: string]: any }) {
  return RequestBase.get<API.GoRuntimeInfoResponse>('/api/v1/admin/system/go-runtime', {}, options);
}

/** 获取系统指标 GET /api/v1/admin/system/metrics */
export async function getSystemMetrics(params?: {
  include_processes?: boolean;
  process_limit?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemMetricsResponse>('/api/v1/admin/system/metrics', params, options);
}

/** 获取格式化系统指标 GET /api/v1/admin/system/metrics/formatted */
export async function getFormattedSystemMetrics(options?: { [key: string]: any }) {
  return RequestBase.get<API.FormattedSystemMetricsResponse>('/api/v1/admin/system/metrics/formatted', {}, options);
}

/** 获取系统健康状态 GET /api/v1/admin/system/health */
export async function getSystemHealth(options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemHealthResponse>('/api/v1/admin/system/health', {}, options);
}

/** 获取历史指标 GET /api/v1/admin/system/metrics/historical */
export async function getHistoricalMetrics(params?: {
  duration?: string;
  interval?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.HistoricalMetricsResponse>('/api/v1/admin/system/metrics/historical', params, options);
}

/** 健康检查 GET /health */
export async function healthCheck(options?: { [key: string]: any }) {
  return RequestBase.get('/health', {}, options);
}

/** 创建设备 POST /api/v1/admin/devices */
export async function createDevice(body: any, options?: { [key: string]: any }) {
  return RequestBase.post('/api/v1/admin/devices', body, options);
}

/** 根据ID获取设备 GET /api/v1/admin/devices/:id */
export async function getDeviceById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get(`/api/v1/admin/devices/${id}`, {}, options);
}

/** 更新设备 PUT /api/v1/admin/devices/:id */
export async function updateDevice(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put(`/api/v1/admin/devices/${id}`, body, options);
}

/** 创建区域 POST /api/v1/admin/regions */
export async function createRegion(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.RegionResponse>('/api/v1/admin/regions', body, options);
}

/** 根据ID获取区域详情 GET /api/v1/admin/regions/{id} */
export async function getRegionById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.RegionResponse>(`/api/v1/admin/regions/${id}`, {}, options);
}

/** 更新区域 PUT /api/v1/admin/regions/{id} */
export async function updateRegion(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.RegionResponse>(`/api/v1/admin/regions/${id}`, body, options);
}

/** 删除区域 DELETE /api/v1/admin/regions/{id} */
export async function deleteRegion(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/regions/${id}`, options);
}

/** 获取定时任务列表 GET /api/v1/admin/scheduled-tasks */
export async function getScheduledTasks(options?: { [key: string]: any }) {
  return RequestBase.get<API.ScheduledTaskListResponse>('/api/v1/admin/scheduled-tasks', {}, options);
}

/** 根据ID获取计划任务详情 GET /api/v1/admin/scheduled-tasks/{id} */
export async function getScheduledTaskById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.ScheduledTaskResponse>(`/api/v1/admin/scheduled-tasks/${id}`, {}, options);
}

/** 创建计划任务 POST /api/v1/admin/scheduled-tasks */
export async function createScheduledTask(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.ScheduledTaskResponse>('/api/v1/admin/scheduled-tasks', body, options);
}

/** 更新计划任务 PUT /api/v1/admin/scheduled-tasks/{id} */
export async function updateScheduledTask(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.ScheduledTaskResponse>(`/api/v1/admin/scheduled-tasks/${id}`, body, options);
}

/** 删除计划任务 DELETE /api/v1/admin/scheduled-tasks/{id} */
export async function deleteScheduledTask(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/scheduled-tasks/${id}`, options);
}

/** 立即执行设备任务 POST /api/v1/admin/scheduled-tasks/{id}/execute */
export async function executeScheduledTaskImmediately(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.ExecuteTaskResponse>(`/api/v1/admin/scheduled-tasks/${id}/execute`, {}, options);
}

/** 复制设备任务 POST /api/v1/admin/scheduled-tasks/{id}/copy */
export async function copyScheduledTask(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.CopyTaskResponse>(`/api/v1/admin/scheduled-tasks/${id}/copy`, {}, options);
}

/** 启用设备任务 POST /api/v1/admin/scheduled-tasks/{id}/enable */
export async function enableScheduledTask(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.ScheduledTaskResponse>(`/api/v1/admin/scheduled-tasks/${id}/enable`, {}, options);
}

/** 禁用设备任务 POST /api/v1/admin/scheduled-tasks/{id}/disable */
export async function disableScheduledTask(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.ScheduledTaskResponse>(`/api/v1/admin/scheduled-tasks/${id}/disable`, {}, options);
}

/** 获取任务执行记录 GET /api/v1/admin/scheduled-tasks/{id}/executions */
export async function getTaskExecutions(taskId: number, limit?: number, options?: { [key: string]: any }) {
  const params: any = {};
  if (limit) {
    params.limit = limit;
  }
  return RequestBase.get<API.TaskExecutionListResponse>(`/api/v1/admin/scheduled-tasks/${taskId}/executions`, params, options);
}

/** 根据ID获取任务执行记录详情 GET /api/v1/admin/scheduled-tasks/executions/{id} */
export async function getTaskExecutionByID(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.TaskExecutionResponse>(`/api/v1/admin/scheduled-tasks/executions/${id}`, {}, options);
}

/** 用户登出 POST /api/v1/admin/users/logout */
export async function logout(body?: { revoke_all?: boolean }, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>('/api/v1/admin/logout', body || {}, options);
}

/** 删除设备 DELETE /api/v1/admin/devices/:id */
export async function deleteDevice(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete(`/api/v1/admin/devices/${id}`, options);
}

/** 同步设备在线状态 POST /api/v1/admin/devices/sync-status */
export async function syncDeviceStatus(options?: { [key: string]: any }) {
  return RequestBase.post('/api/v1/admin/devices/sync-status', {}, options);
}

/** 获取设备传感器数据 GET /api/v1/admin/devices/:deviceId/sensors */
export async function getDeviceSensors(deviceId: string, params?: any, options?: { [key: string]: any }) {
  return RequestBase.get(`/api/v1/admin/devices/${deviceId}/sensors`, params, options);
}

/** 获取设备API密钥列表 GET /api/v1/admin/device-api-keys */
export async function getDeviceApiKeys(options?: { [key: string]: any }) {
  return RequestBase.get<API.DeviceApiKeyResponse>('/api/v1/admin/device-api-keys', {}, options);
}

/** 创建设备API密钥 POST /api/v1/admin/device-api-keys */
export async function createDeviceApiKey(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.DeviceApiKeyResponse>('/api/v1/admin/device-api-keys', body, options);
}

/** 更新设备API密钥 PUT /api/v1/admin/device-api-keys/{id} */
export async function updateDeviceApiKey(id: string, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.DeviceApiKeyResponse>(`/api/v1/admin/device-api-keys/${id}`, body, options);
}

/** 删除设备API密钥 DELETE /api/v1/admin/device-api-keys/{id} */
export async function deleteDeviceApiKey(id: string, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/device-api-keys/${id}`, options);
}

/** 批量删除设备API密钥 DELETE /api/v1/admin/device-api-keys/batch */
export async function batchDeleteDeviceApiKeys(body: { ids: string[] }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/device-api-keys/batch', options, body);
}

/** 获取传感器数据列表 GET /api/v1/admin/sensor-data */
export async function getSensorData(params?: any, options?: { [key: string]: any }) {
  return RequestBase.get<API.SensorDataListResponse>('/api/v1/admin/sensor-data', params, options);
}

/** 获取水下传感器数据列表 GET /api/v1/admin/underwater-sensor-data */
export async function getUnderwaterSensorData(params?: {
  page?: number;
  pageSize?: number;
  deviceId?: number;
  startTime?: string;
  endTime?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.SensorDataListResponse>('/api/v1/admin/underwater-sensor-data', params, options);
}

/** 根据ID获取水下传感器数据详情 GET /api/v1/admin/underwater-sensor-data/{id} */
export async function getUnderwaterSensorDataById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.SensorDataResponse>(`/api/v1/admin/underwater-sensor-data/${id}`, {}, options);
}

/** 删除水下传感器数据 DELETE /api/v1/admin/underwater-sensor-data/{id} */
export async function deleteUnderwaterSensorData(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/underwater-sensor-data/${id}`, options);
}

/** 批量删除水下传感器数据 DELETE /api/v1/admin/underwater-sensor-data/batch */
export async function batchDeleteUnderwaterSensorData(body: { ids: number[] }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/underwater-sensor-data/batch', options, body);
}

/** 获取传感器数据详情 GET /api/v1/admin/sensor-data/{id} */
export async function getSensorDataById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.SensorDataResponse>(`/api/v1/admin/sensor-data/${id}`, {}, options);
}

/** 获取设备传感器数据 GET /api/v1/admin/sensor-data/device/{deviceId} */
export async function getDeviceSensorData(deviceId: number, params?: {
  startTime?: string;
  endTime?: string;
  limit?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.SensorDataListResponse>(`/api/v1/admin/sensor-data/device/${deviceId}`, params, options);
}

/** 获取传感器统计数据 GET /api/v1/admin/sensor-data/statistics */
export async function getSensorDataStatistics(params: {
  deviceId?: number;
  sensorId?: number;
  startTime: string;
  endTime: string;
  statisticType: 'avg' | 'max' | 'min' | 'sum' | 'count';
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.SensorDataStatisticsResponse>('/api/v1/admin/sensor-data/statistics', params, options);
}

/** 创建传感器数据 POST /api/v1/admin/sensor-data */
export async function createSensorData(body: API.SensorData, options?: { [key: string]: any }) {
  return RequestBase.post<API.SensorDataResponse>('/api/v1/admin/sensor-data', body, options);
}

/** 更新传感器数据 PUT /api/v1/admin/sensor-data/{id} */
export async function updateSensorData(id: number, body: Partial<API.SensorData>, options?: { [key: string]: any }) {
  return RequestBase.put<API.SensorDataResponse>(`/api/v1/admin/sensor-data/${id}`, body, options);
}

/** 删除传感器数据 DELETE /api/v1/admin/sensor-data/{id} */
export async function deleteSensorData(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/sensor-data/${id}`, options);
}

/** 批量删除传感器数据 DELETE /api/v1/admin/sensor-data/batch */
export async function batchDeleteSensorData(body: { ids: number[] }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/sensor-data/batch', options, body);
}

/** 批量删除传感器数据（根据ID列表） DELETE /api/v1/admin/sensor-data/batch */
export async function batchDeleteSensorDataByIds(body: { ids: number[] }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/sensor-data/batch', options, body);
}

/** 批量删除传感器数据（根据设备ID和时间范围） DELETE /api/v1/admin/sensor-data/batch */
export async function batchDeleteSensorDataByDeviceAndTime(body: {
  device_id: number;
  start_time: string;
  end_time: string;
}, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/sensor-data/batch', options, body);
}

/** 获取相机文件列表 GET /api/v1/admin/camera-files */
export async function getMonitorFiles(params?: API.CameraFileSearchParams, options?: { [key: string]: any }) {
  return RequestBase.get<API.CameraFileResponse>('/api/v1/admin/monitor-files', params, options);
}

export async function getCameraFiles(params?: API.CameraFileSearchParams, options?: { [key: string]: any }) {
  return RequestBase.get<API.CameraFileListResponse>('/api/v1/admin/camera-files', params, options);
}

/** 根据ID获取相机文件详情 GET /api/v1/admin/camera-files/{id} */
export async function getCameraFileById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.CameraFileResponse>(`/api/v1/admin/camera-files/${id}`, {}, options);
}

/** 删除相机文件 DELETE /api/v1/admin/camera-files/{id} */
export async function deleteCameraFile(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete(`/api/v1/admin/camera-files/${id}`, options);
}

/** 批量删除相机文件 DELETE /api/v1/admin/camera-files/batch */
export async function batchDeleteCameraFiles(body: API.CameraFileBatchDeleteRequest, options?: { [key: string]: any }) {
  return RequestBase.delete<API.CameraFileBatchDeleteResponse>('/api/v1/admin/camera-files/batch', options, body);
}

/** 获取区域组列表 GET /api/v1/admin/area-groups */
export async function getAreaGroups(params?: any, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaGroupListResponse>('/api/v1/admin/area-groups', params, options);
}

/** 根据ID获取区域组详情 GET /api/v1/admin/area-groups/{id} */
export async function getAreaGroupById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaGroupResponse>(`/api/v1/admin/area-groups/${id}`, {}, options);
}

/** 创建区域组 POST /api/v1/admin/area-groups */
export async function createAreaGroup(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.AreaGroupResponse>('/api/v1/admin/area-groups', body, options);
}

/** 更新区域组 PUT /api/v1/admin/area-groups/{id} */
export async function updateAreaGroup(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.AreaGroupResponse>(`/api/v1/admin/area-groups/${id}`, body, options);
}

/** 删除区域组 DELETE /api/v1/admin/area-groups/{id} */
export async function deleteAreaGroup(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/area-groups/${id}`, options);
}

/** 导出区域组数据 GET /api/v1/admin/area-groups/export */
export async function exportAreaGroups(options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaGroupExportResponse>('/api/v1/admin/area-groups/export', {}, options);
}

/** 获取区域图像列表 GET /api/v1/admin/area-images */
export async function getAreaImages(params?: API.AreaImageSearchParams, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaImageListResponse>('/api/v1/admin/area-images', params, options);
}

/** 根据ID获取区域图像详情 GET /api/v1/admin/area-images/{id} */
export async function getAreaImageById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaImageResponse>(`/api/v1/admin/area-images/${id}`, {}, options);
}

/** 创建区域图像 POST /api/v1/admin/area-images */
export async function createAreaImage(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.AreaImageResponse>('/api/v1/admin/area-images', body, options);
}

/** 更新区域图像 PUT /api/v1/admin/area-images/{id} */
export async function updateAreaImage(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.AreaImageResponse>(`/api/v1/admin/area-images/${id}`, body, options);
}

/** 删除区域图像 DELETE /api/v1/admin/area-images/{id} */
export async function deleteAreaImage(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/area-images/${id}`, options);
}

/** 导出区域图像数据 GET /api/v1/admin/area-images/export */
export async function exportAreaImages(options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaImageExportResponse>('/api/v1/admin/area-images/export', {}, options);
}

/** 批量删除模型 DELETE /api/v1/admin/ml-models/batch */
export async function batchDeleteModels(body: API.BatchDeleteRequest, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BatchDeleteResponse>('/api/v1/admin/ml-models/batch', options, body);
}

/** 导出模型数据 GET /api/v1/admin/ml-models/export */
export async function exportModels(options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelExportResponse>('/api/v1/admin/ml-models/export', {}, options);
}

/** 启用模型 POST /api/v1/admin/ml-models/:id/enable */
export async function enableModel(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/ml-models/${id}/enable`, {}, options);
}

/** 停止模型 POST /api/v1/admin/ml-models/:id/stop */
export async function stopModel(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/ml-models/${id}/stop`, {}, options);
}

/** 上传模型文件到华为OBS POST /api/v1/admin/ml-models/:id/upload */
export async function uploadModelFile(id: number, file: File, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/ml-models/${id}/upload`, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/** 删除模型文件 DELETE /api/v1/admin/ml-models/:id/file */
export async function deleteModelFile(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/ml-models/${id}/file`, options);
}

/** 根据标签查询模型 GET /api/v1/admin/ml-models/tags */
export async function getModelsByTags(tags: string[], options?: { [key: string]: any }) {
  const params = { tags: tags.join(',') };
  return RequestBase.get<API.MLModelListResponse>('/api/v1/admin/ml-models/tags', params, options);
}

/** 根据作者查询模型 GET /api/v1/admin/ml-models/author/:author */
export async function getModelsByAuthor(author: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.MLModelListResponse>(`/api/v1/admin/ml-models/author/${author}`, {}, options);
}

/** 根据模型编号查询模型 GET /api/v1/admin/ml-models/code/:code */
export async function getModelByCode(code: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.MLModelResponse>(`/api/v1/admin/ml-models/code/${code}`, {}, options);
}

/** 根据类型查询模型 GET /api/v1/admin/ml-models/type/:type */
export async function getModelsByType(type: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.MLModelListResponse>(`/api/v1/admin/ml-models/type/${type}`, {}, options);
}

/** 根据状态查询模型 GET /api/v1/admin/ml-models/status/:status */
export async function getModelsByStatus(status: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.MLModelListResponse>(`/api/v1/admin/ml-models/status/${status}`, {}, options);
}

/** 部署模型到华为ModelArts POST /api/v1/admin/ml-models/{id}/deploy */
export async function deployModel(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/ml-models/${id}/deploy`, {}, options);
}

/** 下架模型（从ModelArts移除） POST /api/v1/admin/ml-models/{id}/undeploy */
export async function undeployModel(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/ml-models/${id}/undeploy`, {}, options);
}

/** 获取模型部署状态 GET /api/v1/admin/ml-models/{id}/deployment-status */
export async function getModelDeploymentStatus(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelDeploymentStatusResponse>(`/api/v1/admin/ml-models/${id}/deployment-status`, {}, options);
}

/** 异步上传模型文件 POST /api/v1/admin/ml-models/upload-async */
export async function uploadModelFileAsync(body: FormData, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>('/api/v1/admin/ml-models/upload-async', body, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/** 导出角色数据 GET /api/admin/roles/export */
export async function exportRoles(options?: { [key: string]: any }) {
  return RequestBase.get<API.RoleExportResponse>('/api/v1/admin/roles/export', {}, options);
}

// ==================== 部门管理API ====================

/** 获取部门列表 GET /api/v1/admin/departments */
export async function getDepartments(params?: {
  page?: number;
  pageSize?: number;
  name?: string;
  code?: string;
  status?: string;
  parent_id?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.DepartmentListResponse>('/api/v1/admin/departments', params, options);
}

/** 获取部门树形结构 GET /api/v1/admin/departments/tree */
export async function getDepartmentTree(options?: { [key: string]: any }) {
  return RequestBase.get<API.DepartmentTreeResponse>('/api/v1/admin/departments/tree', {}, options);
}

/** 获取部门详情 GET /api/v1/admin/departments/:id */
export async function getDepartmentById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.DepartmentResponse>(`/api/v1/admin/departments/${id}`, {}, options);
}

/** 创建部门 POST /api/v1/admin/departments */
export async function createDepartment(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.DepartmentResponse>('/api/v1/admin/departments', body, options);
}

/** 更新部门 PUT /api/v1/admin/departments/:id */
export async function updateDepartment(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.DepartmentResponse>(`/api/v1/admin/departments/${id}`, body, options);
}

/** 删除部门 DELETE /api/v1/admin/departments/:id */
export async function deleteDepartment(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/departments/${id}`, options);
}

/** 获取部门下的用户 GET /api/v1/admin/departments/:id/users */
export async function getDepartmentUsers(id: number, params?: {
  page?: number;
  pageSize?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.UserListResponse>(`/api/v1/admin/departments/${id}/users`, params, options);
}

// ==================== 角色管理API ====================

/** 获取角色列表 GET /api/v1/admin/roles */
export async function getRoles(params?: {
  page?: number;
  pageSize?: number;
  name?: string;
  code?: string;
  status?: string;
  category?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.RoleListResponse>('/api/v1/admin/roles', params, options);
}

/** 获取角色详情 GET /api/admin/roles/:id */
export async function getRoleById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.RoleResponse>(`/api/v1/admin/roles/${id}`, {}, options);
}

/** 创建角色 POST /api/admin/roles */
export async function createRole(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.RoleResponse>('/api/v1/admin/roles', body, options);
}

/** 更新角色 PUT /api/admin/roles/:id */
export async function updateRole(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.RoleResponse>(`/api/v1/admin/roles/${id}`, body, options);
}

/** 删除角色 DELETE /api/admin/roles/:id */
export async function deleteRole(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/roles/${id}`, options);
}

/** 为角色分配权限 POST /api/admin/roles/:id/permissions */
export async function assignPermissionsToRole(id: number, body: { permission_ids: number[] }, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/roles/${id}/permissions`, body, options);
}

/** 获取角色的权限 GET /api/admin/roles/:id/permissions */
export async function getRolePermissions(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.PermissionListResponse>(`/api/v1/admin/roles/${id}/permissions`, {}, options);
}

/** 为用户分配角色（单个角色） POST /api/admin/users/:id/role */
export async function assignRoleToUser(id: number, body: { role_id: number }, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/users/${id}/role`, body, options);
}

/** 获取用户的角色（单个角色） GET /api/admin/users/:id/role */
export async function getUserRole(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.UserRoleResponse>(`/api/v1/admin/users/${id}/role`, {}, options);
}

/** 获取用户的权限 GET /api/admin/users/:id/permissions */
export async function getUserPermissions(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.PermissionListResponse>(`/api/v1/admin/users/${id}/permissions`, {}, options);
}

/** 检查用户是否有特定权限 GET /api/admin/users/:id/check-permission */
export async function checkUserPermission(id: number, params: { permission: string }, options?: { [key: string]: any }) {
  return RequestBase.get<API.CheckPermissionResponse>(`/api/v1/admin/users/${id}/check-permission`, params, options);
}

/** 获取权限列表 GET /api/v1/admin/permissions */
export async function getPermissions(params?: {
  page?: number;
  pageSize?: number;
  name?: string;
  code?: string;
  category?: string;
  status?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.PermissionListResponse>('/api/v1/admin/permissions', params, options);
}

/** 获取权限选项（用于下拉选择） GET /api/v1/admin/permissions/options */
export async function getPermissionOptions(options?: { [key: string]: any }) {
  return RequestBase.get<API.PermissionOptionListResponse>('/api/v1/admin/permissions/options', {}, options);
}

// ==================== 文件管理API ====================

/** 列出文件/文件夹 GET /api/v1/admin/files */
export async function listFiles(params?: { path?: string }, options?: { [key: string]: any }) {
  return RequestBase.get<API.BaseResponse>('/api/v1/admin/files', params, options);
}

/** 获取文件详情 GET /api/v1/admin/files/info */
export async function getFileInfo(params: { path: string }, options?: { [key: string]: any }) {
  return RequestBase.get<API.BaseResponse>('/api/v1/admin/files/info', params, options);
}

/** 创建文件夹 POST /api/v1/admin/files/folder */
export async function createFolder(body: { path: string }, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>('/api/v1/admin/files/folder', body, options);
}

/** 移动文件/文件夹 PUT /api/v1/admin/files/move */
export async function moveFile(body: { source: string, destination: string }, options?: { [key: string]: any }) {
  return RequestBase.put<API.BaseResponse>('/api/v1/admin/files/move', body, options);
}

/** 重命名文件/文件夹 PUT /api/v1/admin/files/rename */
export async function renameFile(body: { path: string, new_name: string }, options?: { [key: string]: any }) {
  return RequestBase.put<API.BaseResponse>('/api/v1/admin/files/rename', body, options);
}

/** 删除文件/文件夹 DELETE /api/v1/admin/files */
export async function deleteFile(params: { path: string }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/files', options, undefined, params);
}

/** 批量删除文件/文件夹 DELETE /api/v1/admin/files/batch */
export async function batchDeleteFiles(body: { paths: string[] }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/files/batch', options, body);
}

/** 搜索文件 GET /api/v1/admin/files/search */
export async function searchFiles(params: { keyword: string, path?: string }, options?: { [key: string]: any }) {
  return RequestBase.get<API.BaseResponse>('/api/v1/admin/files/search', params, options);
}

/** 获取文件统计信息 GET /api/v1/admin/files/stats */
export async function getFileStats(options?: { [key: string]: any }) {
  return RequestBase.get<API.BaseResponse>('/api/v1/admin/files/stats', {}, options);
}

// ==================== 地图仪表盘管理API ====================

/** 获取地图仪表盘数据 GET /api/v1/admin/map/dashboard */
export async function getMapDashboard(options?: { [key: string]: any }) {
  return RequestBase.get<API.MapDashboardResponse>('/api/v1/admin/map/dashboard', {}, options);
}

// ==================== 模型结果管理API ====================

/** 获取模型结果列表 GET /api/v1/admin/model-results */
export async function getModelResults(params?: API.ModelResultSearchParams, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelResultListResponse>('/api/v1/admin/model-results', params, options);
}

/** 获取单个模型结果 GET /api/v1/admin/model-results/:id */
export async function getModelResultById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelResultResponse>(`/api/v1/admin/model-results/${id}`, {}, options);
}

/** 创建模型结果 POST /api/v1/admin/model-results */
export async function createModelResult(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.ModelResultResponse>('/api/v1/admin/model-results', body, options);
}

/** 更新模型结果 PUT /api/v1/admin/model-results/:id */
export async function updateModelResult(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.ModelResultResponse>(`/api/v1/admin/model-results/${id}`, body, options);
}

/** 删除模型结果 DELETE /api/v1/admin/model-results/:id */
export async function deleteModelResult(id: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/model-results/${id}`, options);
}

/** 批量删除模型结果（根据ID列表） DELETE /api/v1/admin/model-results/batch */
export async function batchDeleteModelResults(body: { ids: number[] }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/model-results/batch', options, body);
}

/** 批量删除模型结果（根据条件） DELETE /api/v1/admin/model-results/batch */
export async function batchDeleteModelResultsByCondition(body: API.ModelResultBatchDeleteRequest, options?: { [key: string]: any }) {
  return RequestBase.delete<API.ModelResultBatchDeleteResponse>('/api/v1/admin/model-results/batch', options, body);
}

/** 按模型名称获取结果 GET /api/v1/admin/model-results/model/:modelName */
export async function getModelResultsByModelName(modelName: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelResultListResponse>(`/api/v1/admin/model-results/model/${modelName}`, {}, options);
}

/** 按设备名称获取结果 GET /api/v1/admin/model-results/device/:deviceName */
export async function getModelResultsByDeviceName(deviceName: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.ModelResultListResponse>(`/api/v1/admin/model-results/device/${deviceName}`, {}, options);
}

/** 导出模型结果 GET /api/v1/admin/model-results/export */
export async function exportModelResults(params?: {
  format?: 'json' | 'excel' | 'csv';
  ids?: string;
  modelName?: string;
  deviceName?: string;
  startTime?: string;
  endTime?: string;
}, options?: { [key: string]: any }) {
  // 对于文件下载，需要设置responseType为blob
  const requestOptions = {
    ...options,
    responseType: 'blob' as const
  };
  
  return RequestBase.get<Blob>('/api/v1/admin/model-results/export', params, requestOptions);
}

// ==================== 操作日志管理API ====================

/** 获取操作日志列表 GET /api/v1/admin/operation-logs */
export async function getOperationLogs(params?: {
  page?: number;
  page_size?: number;
  user_id?: number;
  username?: string;
  operation?: string;
  module?: string;
  action?: string;
  status?: string;
  resource_type?: string;
  resource_id?: string;
  request_method?: string;
  ip_address?: string;
  start_time?: string;
  end_time?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.OperationLogListResponse>('/api/v1/admin/operation-logs', params, options);
}

/** 获取单个操作日志 GET /api/v1/admin/operation-logs/{id} */
export async function getOperationLogById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.OperationLogResponse>(`/api/v1/admin/operation-logs/${id}`, {}, options);
}

/** 删除旧操作日志 DELETE /api/v1/admin/operation-logs/old */
export async function deleteOldOperationLogs(params?: { days?: number }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>('/api/v1/admin/operation-logs/old', options, undefined, params);
}

/** 获取操作日志统计 GET /api/v1/admin/operation-logs/statistics */
export async function getOperationLogStatistics(params?: {
  days?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.OperationLogStatisticsResponse>('/api/v1/admin/operation-logs/statistics', params, options);
}

// ==================== 登录日志管理API ====================

/** 获取登录日志列表 GET /api/v1/admin/login-logs */
export async function getLoginLogs(params?: {
  page?: number;
  page_size?: number;
  user_id?: number;
  username?: string;
  status?: string;
  ip_address?: string;
  start_time?: string;
  end_time?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.LoginLogListResponse>('/api/v1/admin/login-logs', params, options);
}

/** 获取单个登录日志 GET /api/v1/admin/login-logs/{id} */
export async function getLoginLogById(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.LoginLogDetailResponse>(`/api/v1/admin/login-logs/${id}`, {}, options);
}

/** 获取登录统计 GET /api/v1/admin/login-logs/statistics */
export async function getLoginLogStatistics(params?: {
  days?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.LoginLogStatisticsResponse>('/api/v1/admin/login-logs/statistics', params, options);
}

/** 删除旧登录日志 DELETE /api/v1/admin/login-logs/old */
export async function deleteOldLoginLogs(params?: { days?: number }, options?: { [key: string]: any }) {
  return RequestBase.delete<API.DeleteOldLoginLogsResponse>('/api/v1/admin/login-logs/old', options, undefined, params);
}

// ==================== 缺失的API ====================

/** 通过设备编号获取设备 GET /api/v1/admin/devices/number/:deviceNumber */
export async function getDeviceByNumber(deviceNumber: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.DeviceResponse>(`/api/v1/admin/devices/number/${deviceNumber}`, {}, options);
}

/** 按区域获取图片 GET /api/v1/admin/area-images/by-area */
export async function getAreaImagesByArea(params: { area_id: number }, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaImageListResponse>('/api/v1/admin/area-images/by-area', params, options);
}

/** 按类型获取图片 GET /api/v1/admin/area-images/by-type */
export async function getAreaImagesByType(params: { image_type: number }, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaImageListResponse>('/api/v1/admin/area-images/by-type', params, options);
}


/** 获取设备相机文件 GET /api/v1/admin/devices/:id/camera-files */
export async function getDeviceCameraFiles(deviceId: number, params?: {
  limit?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.CameraFileListResponse>(`/api/v1/admin/devices/${deviceId}/camera-files`, params, options);
}

/** 获取最新设备相机文件 GET /api/v1/admin/devices/:id/camera-files/latest */
export async function getLatestDeviceCameraFile(deviceId: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.CameraFileResponse>(`/api/v1/admin/devices/${deviceId}/camera-files/latest`, {}, options);
}

/** 创建相机文件 POST /api/v1/admin/camera-files */
export async function createCameraFile(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.CameraFileResponse>('/api/v1/admin/camera-files', body, options);
}

/** 更新相机文件 PUT /api/v1/admin/camera-files/:id */
export async function updateCameraFile(id: number, body: any, options?: { [key: string]: any }) {
  return RequestBase.put<API.CameraFileResponse>(`/api/v1/admin/camera-files/${id}`, body, options);
}

/** 导出相机文件为ZIP GET /api/v1/admin/camera-files/export */
export async function exportCameraFiles(ids?: number[], options?: { [key: string]: any }) {
  const params: any = {};
  if (ids && ids.length > 0) {
    params.ids = ids.join(',');
  }
  return RequestBase.get('/api/v1/admin/camera-files/export', params, { 
    ...options,
    responseType: 'blob'
  });
}

/** 上传文件 POST /api/v1/admin/files/upload */
export async function uploadFile(body: any, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>('/api/v1/admin/files/upload', body, options);
}

/** 获取登录日志（增强版） GET /api/v1/admin/login-logs */
export async function getEnhancedLoginLogs(params?: {
  page?: number;
  page_size?: number;
  user_id?: number;
  username?: string;
  status?: string;
  ip_address?: string;
  start_time?: string;
  end_time?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.EnhancedLoginLogListResponse>('/api/v1/admin/login-logs', params, options);
}

/** 获取登录统计（增强版） GET /api/v1/admin/login-logs/statistics */
export async function getEnhancedLoginStatistics(params?: {
  days?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.EnhancedLoginStatisticsResponse>('/api/v1/admin/login-logs/statistics', params, options);
}

// ==================== 行政区域管理API ====================

/** 获取行政区域选项 GET /api/admin/area-groups/admin/options */
export async function getAdministrativeOptions(params?: {
  province_code?: string;
  city_code?: string;
  district_code?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.AdministrativeOptionsResponse>('/api/v1/admin/area-groups/admin/options', params, options);
}

/** 验证行政区域名称 GET /api/admin/area-groups/admin/validate */
export async function validateAdministrativeRegion(params?: {
  province?: string;
  city?: string;
  district?: string;
  street?: string;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.AdministrativeValidationResponse>('/api/v1/admin/area-groups/admin/validate', params, options);
}

/** 获取区域组行政区域详情 GET /api/admin/area-groups/{id}/admin-details */
export async function getAreaGroupAdminDetails(id: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaGroupAdminDetailsResponse>(`/api/admin/v1/area-groups/${id}/admin-details`, {}, options);
}

/** 按行政区域搜索区域组 GET /api/admin/area-groups/admin/search */
export async function searchAreaGroupsByAdminRegion(params?: {
  province?: string;
  city?: string;
  district?: string;
  street?: string;
  page?: number;
  pageSize?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.get<API.AreaGroupListResponse>('/api/v1/admin/area-groups/admin/search', params, options);
}

/** 初始化相机配置 POST /api/v1/admin/devices/:id/initialize-camera */
export async function initializeCamera(deviceId: number, config?: {
  server?: string;
  accessKey?: string;
  secretKey?: string;
  bucket?: string;
  picFolder?: string;
  videoFolder?: string;
}, options?: { [key: string]: any }) {
  // 构建相机配置消息，根据Go测试文件中的结构
  const cameraConfig = {
    id: "8", // 根据Go文件，id为"8"
    method: "setConfig",
    data: {
      type: "huaweiObs",
      config: config || {
        server: "obs.cn-east-3.myhuaweicloud.com",
        accessKey: "HPUALD1DAPY5DYFMIJ1Y",
        secretKey: "a4I2m8BP0Rp8paNvCS51ANVsWKP3H8SrB0wQuNe1",
        bucket: "aquaseen",
        picFolder: "/pic",
        videoFolder: "/video",
      }
    }
  };
  
  return RequestBase.post(`/api/v1/admin/devices/${deviceId}/initialize-camera`, cameraConfig, options);
}

// ==================== 系统设置管理API ====================

/** 获取所有系统设置 GET /api/v1/admin/system/settings */
export async function getAllSystemSettings(options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemSettingListResponse>('/api/v1/admin/system/settings', {}, options);
}

/** 按分类获取系统设置 GET /api/v1/admin/system/settings/category/{category} */
export async function getSystemSettingsByCategory(category: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemSettingListResponse>(`/api/v1/admin/system/settings/category/${category}`, {}, options);
}

/** 根据键获取系统设置 GET /api/v1/admin/system/settings/{key} */
export async function getSystemSettingByKey(key: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemSettingResponse>(`/api/v1/admin/system/settings/${key}`, {}, options);
}

/** 更新系统设置 PUT /api/v1/admin/system/settings/{key} */
export async function updateSystemSetting(key: string, body: { value: string }, options?: { [key: string]: any }) {
  return RequestBase.put<API.SystemSettingResponse>(`/api/v1/admin/system/settings/${key}`, body, options);
}

/** 批量更新系统设置 PUT /api/v1/admin/system/settings/batch */
export async function updateSystemSettingsBatch(body: Record<string, string>, options?: { [key: string]: any }) {
  return RequestBase.put<API.SystemSettingListResponse>('/api/v1/admin/system/settings/batch', body, options);
}

/** 获取系统配置 GET /api/v1/admin/system/config */
export async function getSystemConfig(options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemConfigResponse>('/api/v1/admin/system/config', {}, options);
}

/** 按分类获取系统配置 GET /api/v1/admin/system/config/{category} */
export async function getSystemConfigByCategory(category: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemConfigResponse>(`/api/v1/admin/system/config/${category}`, {}, options);
}

/** 重置系统设置为默认值 POST /api/v1/admin/system/settings/{key}/reset */
export async function resetSystemSetting(key: string, options?: { [key: string]: any }) {
  return RequestBase.post<API.SystemSettingResponse>(`/api/v1/admin/system/settings/${key}/reset`, {}, options);
}

/** 按分类重置系统设置为默认值 POST /api/v1/admin/system/settings/category/{category}/reset */
export async function resetSystemSettingsByCategory(category: string, options?: { [key: string]: any }) {
  return RequestBase.post<API.SystemSettingListResponse>(`/api/v1/admin/system/settings/category/${category}/reset`, {}, options);
}

/** 获取系统维护状态 GET /api/v1/admin/system/maintenance/status */
export async function getSystemMaintenanceStatus(options?: { [key: string]: any }) {
  return RequestBase.get<API.SystemMaintenanceStatusResponse>('/api/v1/admin/system/maintenance/status', {}, options);
}

/** 更新系统维护状态 PUT /api/v1/admin/system/maintenance/status */
export async function updateSystemMaintenanceStatus(body: { maintenance_mode: boolean }, options?: { [key: string]: any }) {
  return RequestBase.put<API.SystemSettingResponse>('/api/v1/admin/system/maintenance/status', body, options);
}

/** 初始化系统设置 POST /api/v1/admin/system/settings/initialize */
export async function initializeSystemSettings(options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>('/api/v1/admin/system/settings/initialize', {}, options);
}

// ==================== 设备控制API ====================

/** 通电相机 POST /api/v1/admin/devices/{id}/power-on */
export async function powerOnCamera(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/power-on`, {}, options);
}

/** 断电相机 POST /api/v1/admin/devices/{id}/power-off */
export async function powerOffCamera(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/power-off`, {}, options);
}

/** 电池通电（MQTT battery_power camSta=1） POST /api/v1/admin/devices/{id}/battery-power-on */
export async function batteryPowerOnCamera(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/battery-power-on`, {}, options);
}

/** 电池断电（MQTT battery_power camSta=0） POST /api/v1/admin/devices/{id}/battery-power-off */
export async function batteryPowerOffCamera(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/battery-power-off`, {}, options);
}

/** 网口二启动（MQTT surveillance surveillance=1） POST /api/v1/admin/devices/{id}/net-port2-on */
export async function netPort2On(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/net-port2-on`, {}, options);
}

/** 网口二关闭（MQTT surveillance surveillance=0） POST /api/v1/admin/devices/{id}/net-port2-off */
export async function netPort2Off(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/net-port2-off`, {}, options);
}

/** 网口三启动（MQTT surveillance-2 surveillance-2=1） POST /api/v1/admin/devices/{id}/net-port3-on */
export async function netPort3On(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/net-port3-on`, {}, options);
}

/** 网口三关闭（MQTT surveillance-2 surveillance-2=0） POST /api/v1/admin/devices/{id}/net-port3-off */
export async function netPort3Off(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/net-port3-off`, {}, options);
}

/** 推杆启动 POST /api/v1/admin/devices/{id}/actuator-on */
export async function actuatorOn(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/actuator-on`, {}, options);
}

/** 推杆关闭 POST /api/v1/admin/devices/{id}/actuator-off */
export async function actuatorOff(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/actuator-off`, {}, options);
}

/** 拍照 POST /api/v1/admin/devices/{id}/take-picture */
export async function takePicture(id: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/take-picture`, {}, options);
}

/** 录像 POST /api/v1/admin/devices/{id}/record-video */
export async function recordVideo(id: number, duration?: number, options?: { [key: string]: any }) {
  const params: any = {};
  if (duration) {
    params.duration = duration;
  }
  return RequestBase.post(`/api/v1/admin/devices/${id}/record-video`, {}, { ...options, params });
}

// ==================== PTZ控制API ====================

/** PTZ控制 POST /api/v1/admin/devices/{id}/ptz-control */
export async function ptzControl(id: number, body: {
  cmd: string;
  speed?: number;
  channel?: number;
}, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/ptz-control`, body, options);
}

/** 停止PTZ操作 POST /api/v1/admin/devices/{id}/ptz-control */
export async function stopPTZ(id: number, channel: number, options?: { [key: string]: any }) {
  return RequestBase.post(`/api/v1/admin/devices/${id}/ptz-control`, { cmd: 'stop', channel }, options);
}

/** 测试设备在线状态 POST /api/v1/admin/devices/{id}/test-online */
export async function testDeviceOnline(id: number, options?: { [key: string]: any }) {
  return RequestBase.post<{device_id: number; device_name: string; board_name: string; test_time: string; online: boolean; message: string;}>(`/api/v1/admin/devices/${id}/test-online`, {}, options);
}

// ==================== 用户会话管理API ====================

/** 获取用户会话列表 GET /api/v1/admin/user-sessions/user/:user_id */
export async function getUserSessions(userId: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.UserSessionListResponse>(`/api/v1/admin/user-sessions/user/${userId}`, {}, options);
}

/** 管理员撤销用户会话 DELETE /api/v1/admin/user-sessions/user/:user_id/:token */
export async function adminRevokeUserSession(userId: number, sessionToken: string, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/user-sessions/user/${userId}/${sessionToken}`, options);
}

/** 管理员撤销用户所有会话 DELETE /api/v1/admin/user-sessions/user/:user_id/all */
export async function adminRevokeAllUserSessions(userId: number, options?: { [key: string]: any }) {
  return RequestBase.delete<API.BaseResponse>(`/api/v1/admin/user-sessions/user/${userId}/all`, options);
}

/** 管理员强制用户下线 POST /api/v1/admin/user-sessions/user/:user_id/force-logout */
export async function adminForceLogoutUser(userId: number, reason?: string, options?: { [key: string]: any }) {
  const params: any = {};
  if (reason) {
    params.reason = reason;
  }
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/user-sessions/user/${userId}/force-logout`, {}, { ...options, params });
}

/** 获取会话统计信息 GET /api/v1/admin/user-sessions/statistics */
export async function getSessionStatistics(options?: { [key: string]: any }) {
  return RequestBase.get<API.SessionStatisticsResponse>('/api/v1/admin/user-sessions/statistics', {}, options);
}

/** 获取用户会话统计 GET /api/v1/admin/user-sessions/user/:user_id/stats */
export async function getUserSessionStats(userId: number, options?: { [key: string]: any }) {
  return RequestBase.get<API.UserSessionStatsResponse>(`/api/v1/admin/user-sessions/user/${userId}/stats`, {}, options);
}

/** 清理过期会话 DELETE /api/v1/admin/user-sessions/cleanup */
export async function cleanExpiredSessions(options?: { [key: string]: any }) {
  return RequestBase.delete<API.CleanupExpiredSessionsResponse>('/api/v1/admin/user-sessions/cleanup', options);
}

/** 根据数据采集板名称获取设备 GET /api/v1/admin/devices/board/:boardName */
export async function getDeviceByBoardName(boardName: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.DeviceResponse>(`/api/v1/admin/devices/board/${boardName}`, {}, options);
}

/** 根据相机名称获取设备 GET /api/v1/admin/devices/camera/:cameraName */
export async function getDeviceByCameraName(cameraName: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.DeviceResponse>(`/api/v1/admin/devices/camera/${cameraName}`, {}, options);
}

/** 获取所有在线用户会话（结合用户信息） */
export async function getOnlineUsers(params?: {
  page?: number;
  pageSize?: number;
  username?: string;
  loginAddress?: string;
}, options?: { [key: string]: any }) {
  // 这个函数需要先获取用户列表，然后为每个用户获取会话信息
  // 这是一个复合函数，实现获取所有在线用户的功能
  const userParams = {
    page: params?.page || 1,
    pageSize: params?.pageSize || 10,
    username: params?.username,
  };
  
  const usersResponse = await getUsers(userParams, options);
  
  if (usersResponse.code !== 200) {
    throw new Error(`获取用户列表失败: ${usersResponse.message}`);
  }
  
  const users = usersResponse.data;
  
  // 获取每个用户的会话信息
  const onlineUsers = [];
  
  for (const user of users) {
    try {
      const sessionsResponse = await getUserSessions(user.id, options);
      if (sessionsResponse.code === 200 && sessionsResponse.data && sessionsResponse.data.length > 0) {
        // 过滤活跃会话
        const activeSessions = sessionsResponse.data.filter((session: API.UserSession) => 
          session.status === 'active' || session.status === 'Active'
        );
        
        // 为每个活跃会话创建在线用户记录
        for (const session of activeSessions) {
          onlineUsers.push({
            id: session.id,
            userId: user.id,
            username: user.username,
            loginName: user.username,
            sessionId: session.session_token,
            clientType: session.client_type,
            deviceType: session.device_type,
            deviceInfo: session.device_info,
            os: session.os,
            browser: session.browser,
            ipAddress: session.ip_address,
            loginLocation: session.location,
            loginTime: session.login_time,
            lastActivity: session.last_activity,
            department: user.department, // 从用户信息中获取部门
          });
        }
      }
    } catch (error) {
      // 忽略单个用户会话获取失败的情况
      console.error(`获取用户 ${user.username} 会话失败:`, error);
    }
  }
  
  // 根据登录地址过滤
  let filteredUsers = onlineUsers;
  if (params?.loginAddress) {
    const searchTerm = params.loginAddress.toLowerCase();
    filteredUsers = onlineUsers.filter((user: any) => 
      (user.ipAddress && user.ipAddress.toLowerCase().includes(searchTerm)) ||
      (user.loginLocation && user.loginLocation.toLowerCase().includes(searchTerm))
    );
  }
  
  // 分页
  const startIndex = ((params?.page || 1) - 1) * (params?.pageSize || 10);
  const endIndex = startIndex + (params?.pageSize || 10);
  const paginatedUsers = filteredUsers.slice(startIndex, endIndex);
  
  return {
    code: 200,
    message: '获取在线用户成功',
    data: {
      list: paginatedUsers,
      total: filteredUsers.length,
      page: params?.page || 1,
      pageSize: params?.pageSize || 10,
    },
  };
}

/** 开始录制 POST /api/v1/admin/devices/gbid/{gbID}/stream/record */
export async function recordStream(gbID: string, duration: number, options?: { [key: string]: any }) {
  return RequestBase.post<API.RecordingResponse>(`/api/v1/admin/devices/gbid/${gbID}/stream/record`, { duration }, options);
}

/** 停止录制 POST /api/v1/admin/devices/gbid/{gbID}/stream/record/stop */
export async function stopRecordStream(gbID: string, options?: { [key: string]: any }) {
  return RequestBase.post<API.BaseResponse>(`/api/v1/admin/devices/gbid/${gbID}/stream/record/stop`, {}, options);
}

/** 获取录制状态 GET /api/v1/admin/devices/gbid/{gbID}/stream/record/status */
export async function getRecordStatus(gbID: string, options?: { [key: string]: any }) {
  return RequestBase.get<API.RecordStatusResponse>(`/api/v1/admin/devices/gbid/${gbID}/stream/record/status`, {}, options);
}

